import { MediaTypeType } from "@/types/mediaType.type";
import { ButtonTypeType } from "@/types/buttonType.type";

export const resolveMediaTemplateIcon = (mediaType: MediaTypeType): string[] | MediaTypeType => {
    switch (mediaType) {
        case MediaTypeType.IMAGE:
            return ["fa", "image"];
        case MediaTypeType.DOCUMENT:
            return ["fa", "file"];
        case MediaTypeType.VIDEO:
            return ["fa", "video"];
    }

    return mediaType;
};

export const resolveTemplateButtonIcon = (buttonType: ButtonTypeType): string[] | undefined => {
    switch (buttonType) {
        case "URL":
            return ["fa", "up-right-from-square"];
        case "PHONE_NUMBER":
            return ["fa", "phone-alt"];
    }
};
